export default __webpack_public_path__ + "89cc9e81e19a4b84971d0248b4ca987f.png";